import { render } from "./research_info.vue?vue&type=template&id=ef2dc4b4&scoped=true"
import script from "./research_info.vue?vue&type=script&lang=js"
export * from "./research_info.vue?vue&type=script&lang=js"

import "./research_info.vue?vue&type=style&index=0&id=ef2dc4b4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2dc4b4"]])

export default __exports__